let dropdown_toggles = document.querySelectorAll('.main-menu .dropdown-toggle');
dropdown_toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
        let parent = toggle.parentElement;
        let dropdown = toggle.nextElementSibling;
        let isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        let isHidden = dropdown.getAttribute('aria-hidden') === 'true';
        console.log(isHidden);

        if (!dropdown.classList.contains('active')) {
            let parents = document.querySelectorAll('.main-menu li.active');
            parents.forEach(function (elem) {
                elem.classList.remove('active');
                let elemToggle = elem.querySelector('.dropdown-toggle');
                elemToggle.setAttribute('aria-expanded', false);
            });
            let dropdowns = document.querySelectorAll('.main-menu .dropdown-menu.active');
            dropdowns.forEach(function (elem) {
                elem.classList.remove('active');
                elem.setAttribute('aria-hidden', true);
            });
        }
        parent.classList.toggle('active');
        dropdown.classList.toggle('active');
        toggle.setAttribute('aria-expanded', String(!isExpanded));
        dropdown.setAttribute('aria-hidden', String(!isHidden));
    });
});

let menu_toggle = document.querySelector('.menu-toggle');
menu_toggle.addEventListener('click', function () {
    menu_toggle.classList.toggle('active');
    let nav = document.querySelector('nav');
    nav.classList.toggle('active');
});